module.exports = __webpack_public_path__ + "static/media/logo.7259bb66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 173
// module chunks = 0